import jQuery from 'jquery';
import Swiper from 'swiper';
import bootstrapBundle from '../../../node_modules/bootstrap/dist/js/bootstrap.bundle.js';

window.$ = jQuery;
window.jQuery = jQuery;
window.Swiper = Swiper;
window.bootstrapBundle = bootstrapBundle;

// NEED TO USE "REQUIRE" IN THIS LIBRARY
const fancybox = require('../../../node_modules/@fancyapps/fancybox/dist/jquery.fancybox');
window.fancybox = fancybox;

import { setupSearchModel, initialFetchFilteredCars, setupConditionCheckboxes, agreeTermsBtnClickListener } from './functions/actionsFilters';
import { swipersInit } from './functions/sliders';
import { uploadFiles } from './functions/uploadFiles';

document.addEventListener('DOMContentLoaded', function() {
  // Inicializando funções de filtro novos/seminovos se estiver na página de seminovos
  const filtersExist = document.getElementById('form-filter-cars');
  if (filtersExist){
    setupSearchModel();
    initialFetchFilteredCars();
    setupConditionCheckboxes();
  }
  // FUNCTION TO CREATE AND INIT SWIPERS
  swipersInit();

  // INIT FUNCTIONS TO CONTROL TERMS AND CONDITIONS
agreeTermsBtnClickListener()

  // FUNCTION TO CONTROL UPLOADS OF FILES
  uploadFiles('.input-upload', '.label-wrapper-image img', '.upload-wrapper-close');

  //SCROLL TOP BUTTON
  $(".btn-scroll-top").click(function() {
    $("html, body").animate({
      scrollTop: 0
    }, 800); 
    return false; 
  });

  //REDIRECT THANKS PAGE
  const redirectHome = document.querySelector('.redirect-countdown');

  if (redirectHome != undefined) {
    let count = 5;

    setInterval(() => {
      if (count >= 0) {
        redirectHome.innerHTML = `${count}s`;
        count--;
      }
    }, 1000)

    setTimeout(() => {
      window.location.href = "/";
    }, 5500);
  }
});